<template>
    <div class="appointment-detail">
        <template v-if="isAppointment">
            <div class="appointment-detail-row">
                <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                    <b>Appointment ID</b>
                </div>
                <div class="appointment-detail-content">
                    {{appointmentId}}
                </div>
            </div>
        </template>

        <template v-if="isConsultation">
            <div class="appointment-detail-row">
                <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                    <b>Consultation ID</b>
                </div>
                <div class="appointment-detail-content">
                    {{consultationId}}
                </div>
            </div>
        </template>

        <div class="appointment-detail-row">
            <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                <b>Date</b>
            </div>
            <div class="appointment-detail-content">
                {{dateDisplay}}
            </div>
        </div>

        <div class="appointment-detail-row">
            <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                <b>Time</b>
            </div>
            <div class="appointment-detail-content">
                {{timeDisplay}}
            </div>
        </div>

        <div class="appointment-detail-row">
            <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                <b>{{participantNameDisplay}}</b>
            </div>
            <div class="appointment-detail-content">
                {{appointmentParticipant ? appointmentParticipant : '-'}}
            </div>
        </div>

        <div v-if="isPatient" class="appointment-detail-row">
            <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                <b>Doctor's Hospital or Clinic Affiliation</b>
            </div>
            <div class="appointment-detail-content">
                {{doctorClinicHospitalName ? doctorClinicHospitalName : '-'}}
            </div>
        </div>

        <template v-if="isDoctor">
            <div class="appointment-detail-row">
                <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                    <b>Patient Gender</b>
                </div>
                <div class="appointment-detail-content">
                    {{patientGender ? patientGender : "Not Specified"}}
                </div>
            </div>

            <div class="appointment-detail-row">
                <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                    <b>Patient Age</b>
                </div>
                <div class="appointment-detail-content">
                    {{patientAge > -1 ? `${patientAge} Years Old`: "Not Specified"}}
                </div>
            </div>
        </template>

        <template v-if="shouldShowPatientMailingAddress">
             <div class="appointment-detail-row">
                <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                    <b>Mailing Address</b>
                </div>
                <div class="appointment-detail-content" v-html="patientMailingAddress">
                </div>
            </div>
        </template>

        <template v-if="isPatient && isAppointment">
            <div class="appointment-detail-row">
                <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                    <b>Status</b>
                </div>
                <div class="appointment-detail-content">
                    <user-appointment-status v-if="appointmentType === 1" :statusId="appointmentStatus"></user-appointment-status>
                </div>
            </div>
        </template>

        <template v-if="hasRemarks">
            <div class="appointment-detail-row">
                <div class="appointment-detail-title" :class="{ 'patient-appointment-detail-title': isPatient }">
                    <b>Remarks</b>
                </div>
                <div class="appointment-detail-content">
                    <p v-if="appointmentRemarksParsed.length === 0">-</p>
                    <p v-else v-html="appointmentRemarksParsed"></p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import userAppointmentStatus from '@/components/appointment-status/user';
import {
    convertToUserReadableDate,
    convertToUserReadableTime,
    replaceLineBreakInHtml
} from '@/utilities';
export default {
    'name': 'AppointmentDetail',
    'components': {
        userAppointmentStatus
    },
    'props': {
        'appointmentParticipant': {
            'type': String,
            'default': ''
        },
        'isAppointment': {
            'type': Boolean,
            'default': false
        },
        'appointmentId': {
            'type': String,
            'default': ''
        },
        'isConsultation': {
            'type': Boolean,
            'default': false
        },
        'consultationId': {
            'type': String,
            'default': ''
        },
        'participantNameDisplay': {
            'type': String,
            'default': 'Participant Name'
        },
        'appointmentDate': {
            'type': String
        },
        'appointmentType': {
            'type': Number,
            'default': 1
        },
        'appointmentStatus': {
            'type': Number,
            'default': 0
        },
        'appointmentRemarks': {
            'type': String,
            'default': ''
        },
        'isPatient': {
            'type': Boolean,
            'default': false
        },
        'isDoctor': {
            'type': Boolean,
            'default': false
        },
        'hasRemarks': {
            'type': Boolean,
            'default': false
        },
        'patientGender': {
            'type': String,
            'default': ''
        },
        'patientAge': {
            'default': -1
        },
        'shouldShowPatientMailingAddress': {
            'type': Boolean,
            'default': false
        },
        'patientMailingAddress': {
            'type': String,
            'default': ''
        },
        'doctorClinicHospitalName': {
            'type': String,
            'default': ''
        }
    },
    'computed': {
        dateDisplay () {
            return this.appointmentDate ? convertToUserReadableDate(this.appointmentDate) : '-';
        },
        timeDisplay () {
            return this.appointmentDate ? convertToUserReadableTime(this.appointmentDate) : '-';
        },
        appointmentRemarksParsed () {
            return replaceLineBreakInHtml(this.appointmentRemarks);
        }
    }
};

</script>

<style>
    .appointment-detail {}

    .appointment-detail .appointment-detail-row .appointment-detail-title {
            margin-bottom: .25rem;
        }

    @media(min-width: 576px) {
        .appointment-detail .appointment-detail-row {
            display: flex;
        }

        .appointment-detail .appointment-detail-row .appointment-detail-title {
            width: 150px;
            margin-bottom: 0;
            margin-right: 1.25rem;
        }

        .appointment-detail .appointment-detail-row .appointment-detail-content {
            display: flex;
            flex: 1;
        }

        .appointment-detail .appointment-detail-row .appointment-detail-title.patient-appointment-detail-title{
            width: 300px;
        }
    }

    .appointment-detail .appointment-detail-row:not(:last-child) {
        margin-bottom: 1.25rem;
    }

    .appointment-detail-content p:last-child {
        margin-bottom: 0;
    }

</style>
